import { type SVGProps } from "react";

import { cn } from "@/shared/helpers/cn.helper";

interface ThumbsDownIconProps extends SVGProps<SVGSVGElement> {
  className?: string;
}

export const ThumbsDownIcon = ({ className, ...props }: ThumbsDownIconProps) => (
  <svg
    className={cn("text-light-400", className)}
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17 14V4M17 14L13.5 20.5C13.1438 21.0973 12.4407 21.4153 11.75 21.25C11.0593 21.0847 10.5527 20.4951 10.5 19.7857V16H6.20577C4.99681 16 4.06195 14.9398 4.21256 13.7405L5.21256 5.74053C5.33823 4.73834 6.18802 4 7.20577 4H17"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
);

export default ThumbsDownIcon;
